import { ITab } from '@cian/components';

export const tabs: ITab[] = [
  { id: 'play', title: 'Играйте дома' },
  { id: 'walk', title: 'Гуляйте дома' },
  { id: 'rest', title: 'Отдыхайте дома' },
];

export const tabsContent: { [key: string]: { video: string } } = {
  play: {
    video: 'lqRUGZpmgAI',
  },
  walk: {
    video: 'YirC7y_cn04',
  },
  rest: {
    video: 'SQp0AMsNaVc',
  },
};
